module.exports = __webpack_public_path__ + "static/media/dec-horizontal-id-back.093490ba.gif";